import * as React from 'react';
import { Grid } from 'react-flexbox-grid';

import { Tabs } from '@components/tabs';
import { SpsModal } from './SpsModal';
import { EditProfileModal } from './EditProfileModal';

export const UserProfilesModal: React.SFC<any> = ({ closeItem, isLoginBasic }) => {
  const items = React.useMemo(
    () => {
      const tabItems = isLoginBasic
        ? [
            {
              label: 'Profil',
              style: { minWidth: 175 },
              content: <EditProfileModal closeItem={closeItem} />
            }
          ]
        : [];
      tabItems.push({
        label: 'Spisová služba',
        style: { minWidth: 175 },
        content: <SpsModal closeItem={closeItem} />
      });
      return tabItems;
    },
    [isLoginBasic]
  );
  return (
    <div>
      <Grid fluid={true}>
        <Tabs items={items} />
      </Grid>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/sidebar/userProfiles/UserProfilesModal.tsx